import $ from 'jquery';


$(document).ready(function () {
    const filterAccordionToggle = document.querySelector('.filter__filters-label');
    const filterAccordionBody = document.querySelector('.filter__filters');
    let viewportWidth = $(window).width();

    if (viewportWidth < 768) {
        $(filterAccordionToggle).click(function () {
            $(filterAccordionToggle).toggleClass("open");
            $(filterAccordionBody).toggleClass("open");
        });
    }
});
    

